module.exports = __webpack_public_path__ + "img/hércules-florence.366deadd.png";